
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wave-3-and-glacier-classic",
      function () {
        return require("private-next-pages/wave-3-and-glacier-classic/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wave-3-and-glacier-classic"])
      });
    }
  